import { useEffect } from "react";
import "./GoogleTranslate.css";

const GOOGLE_TRANSLATE_SCRIPT_ID = "google-translate-script";

const GoogleTranslate = () => {
  useEffect(() => {
    const initializeGoogleTranslate = () => {
      const TranslateElement = window.google?.translate?.TranslateElement;
      const target = document.getElementById("google_translate_element");

      if (!TranslateElement || !target || target.dataset.initialized === "true") {
        return;
      }

      new TranslateElement(
        {
          pageLanguage: "en",
          autoDisplay: false,
        },
        target.id
      );
      target.dataset.initialized = "true";
    };

    window.googleTranslateElementInit = initializeGoogleTranslate;

    if (window.google?.translate?.TranslateElement) {
      initializeGoogleTranslate();
      return;
    }

    if (!document.getElementById(GOOGLE_TRANSLATE_SCRIPT_ID)) {
      const script = document.createElement("script");
      script.id = GOOGLE_TRANSLATE_SCRIPT_ID;
      script.src =
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      script.onerror = () => {
        console.error("Google Translate could not be loaded.");
      };
      document.body.appendChild(script);
    }
  }, []);

  return (
    <aside className="site-translate" aria-label="Website language">
      <span className="site-translate-label">🌐 Language</span>
      <div id="google_translate_element" />
    </aside>
  );
};

export default GoogleTranslate;
